import Button from '@sharedComponents/Button';
import FlexBox from '@sharedComponents/FlexBox';
import Typography from '@sharedComponents/Typography';

/**
 * Confirmation dialog body, rendered inside the shared Modal through the ModalContext.
 * Domain-agnostic: the caller supplies the message, the button labels and the callbacks.
 * `confirmTheme` lets a destructive action request the red "danger" confirm button.
 */
const ConfirmModal = ({
    message = '',
    cancelLabel = 'Cancel',
    confirmLabel = 'Confirm',
    confirmTheme = 'primary',
    onCancel = () => {},
    onConfirm = () => {},
}) => (
    <FlexBox flexDirection="column" gap="l">
        {message && <Typography>{message}</Typography>}
        <FlexBox justifyContent="flex-end" gap="s">
            <Button outline label={cancelLabel} action={onCancel} />
            <Button theme={confirmTheme} label={confirmLabel} action={onConfirm} />
        </FlexBox>
    </FlexBox>
);

export default ConfirmModal;
